import { useQuery } from "@tanstack/react-query";
import { api } from "utils/hostname";
import { PhoneCountry } from "types/PhoneCountries";
import url from "../url";

export const usePhoneCountries = () => {
  const { data } = useQuery({
    queryKey: ["phoneCountries"],
    queryFn: () =>
      api().get<PhoneCountry[]>(url.config.api.catalogs.phoneCountries),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  return { data: data?.data };
};
